export const OPEN_OFFER_DETAILS_POST_LOGIN_ACTION = 'open-offer-details';
export const ACTIVATE_OFFER_POST_LOGIN_ACTION = 'activate-offer';

export type OfferPostLoginParams = {
    gtmSection: string;
    offerId: string;
};

export type PostLoginIntent =
    | { action: typeof OPEN_OFFER_DETAILS_POST_LOGIN_ACTION; params: OfferPostLoginParams }
    | { action: typeof ACTIVATE_OFFER_POST_LOGIN_ACTION; params: OfferPostLoginParams };
